export default (
  state = { isLoading: false, packages: [], wasSend: false, step: 'first' },
  action
) => {
  switch (action.type) {
    case 'FETCH_PACKAGES_BY_SUPPLIERID':
      return { ...state, isLoading: true, packages: [] }
    case 'FETCH_PACKAGES_BY_SUPPLIERID_SUCCESS':
      return { ...state, isLoading: false, packages: action.payload.data }
    case 'FETCH_PACKAGES_BY_SUPPLIERID_FAIL':
      return { ...state, isLoading: false, error: action.error }
    case 'REDEMPTION_FUEL_CREDIT':
      return { ...state, sendRedemption: true }
    case 'REDEMPTION_FUEL_CREDIT_SUCCESS':
      return {
        ...state,
        sendRedemption: false,
        step: 'first'
      }
    case 'REDEMPTION_FUEL_CREDIT_FAIL':
      return {
        ...state,
        sendRedemption: false,
        sendRedemptionError: true,
        packageSelected: action.packageSelected,
        step: 'first'
      }
    case 'REDEMPTION_FUEL_CREDIT_CLOSE_ERROR':
      return { ...state, sendRedemptionError: false }
    case 'CHANGE_STEP_FUEL_CREDIT':
      return { ...state, step: action.step }
    case 'REDIRECT_ERROR_FUEL_CREDIT':
      return {
        descriptionErrorFuelCredit: action.descriptionErrorFuelCredit,
        sendRedemptionError: true,
        step: 'first',
        packageSelected: action.packageSelected
      }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/features/Services/FuelCredit/reducer.js